import { render, staticRenderFns } from "./o-article-wrapper.vue?vue&type=template&id=27c4620a"
import script from "./o-article-wrapper.vue?vue&type=script&lang=js"
export * from "./o-article-wrapper.vue?vue&type=script&lang=js"
import style0 from "./o-article-wrapper.vue?vue&type=style&index=0&id=27c4620a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports